"use strict";

(function () {
  "use strict";

  angular.module("damages", ["ui.router", "my-ag-grid", "common", "damages.informManager", "damages.performInsurerEdi", "damages.scheduleDepa", "damages.docsInsurer", "damages.askSomeone"]);
})();